const loadGoogleMapsApi = require('load-google-maps-api');
class Map {

  static loadGoogleMapsApi() {
    return loadGoogleMapsApi({ key: 'AIzaSyAQWJvC6CIQ1-UlH9Lu9d7MxBBqs4GsAnc' });
  }

  static createMap(googleMaps, mapElement, latLng = { lat: 50.6, lng: 5.15 }, zoom = 9) {
    return new googleMaps.Map(mapElement, {
      center: latLng,
      zoom: zoom,
			scrollwheel: false,
      styles: [
        {
          "featureType":
            "administrative",
          "elementType":
            "labels.text.fill",
          "stylers":
            [{
              "color":
                "#444444"
            }]
        },
        {
          "featureType":
            "landscape",
          "elementType":
            "all",
          "stylers":
            [{
              "color":
                "#f2f2f2"
            }]
        },
        {
          "featureType":
            "poi",
          "elementType":
            "all",
          "stylers":
            [{
              "visibility":
                "off"
            }]
        },
        {
          "featureType":
            "road",
          "elementType":
            "all",
          "stylers":
            [{
              "saturation":
                -100
            }, {
              "lightness":
                45
            }]
        },
        {
          "featureType":"road.highway",
          "elementType":"all",
          "stylers":[{"visibility":"simplified"}]
        },
        {
          "featureType":"road.arterial",
          "elementType":"labels.icon",
          "stylers":[{"visibility":"off"}]
        },
        {
          "featureType":"transit",
          "elementType":"all",
          "stylers":[{"visibility":"off"}]
        },
        {
          "featureType":"water",
          "elementType":"all",
          "stylers":[{"color":"#3ac1e1"}, {"visibility":"on"}]
        }
      ]
    });
  }

  static addMarker(googleMaps, map, place){
    return new googleMaps.Marker({
      position: { lat: place.latitude, lng: place.longitude },
      map: map,
      title: place.title,
      icon: {
        path: "M11.5155 24.1395C11.4741 17.5149 16.5913 12.0904 22.924 12.0462C29.2568 12.002 34.4423 17.3559 34.4845 23.9805C34.5268 30.6051 29.4087 36.0296 23.076 36.0738C16.7432 36.1171 11.5577 30.7641 11.5155 24.1395M45.9995 23.9006C45.9158 10.6344 35.5302 -0.0878534 22.8477 0.00054266C10.1651 0.0880887 -0.0839829 10.9523 0.000518793 24.2194C0.0671451 34.8243 6.72003 43.7965 15.8641 46.9278C14.213 55.1614 16.7318 64.0715 23.1995 70L30.7884 60.9394C27.0809 57.5413 25.9823 52.184 27.6391 47.6248C38.1652 45.3613 46.0734 35.5604 45.9995 23.9006",
        scale: 0.70,				
        strokeOpacity: 0,
        fillColor: place.color,
        fillOpacity: 1,
        scrollwheel: false,
        anchor: {
          x: 24,
          y: 70
        }	
      }	
    });
  }
}

export { Map };